
export { getDefaultOrganizationRoute } from "/tmp/build_c58462f6/packages/common/lib-esm/helpers/auth.js"